import buildContentfulAssetUrl from './buildContentfulAssetUrl';

export default function(url, params = {}) {
  // if url is not modified do not generate srcSet
  if (buildContentfulAssetUrl(url, params) === url) {
    return null;
  }

  const pixelRatios = params.pixelRatios || [1, 1.5, 2];

  return pixelRatios
    .map(
      pixelRatio =>
        `${buildContentfulAssetUrl(url, {
          ...params,
          width: params.width && params.width * pixelRatio,
          height: params.height && params.height * pixelRatio,
        })} ${pixelRatio}x`,
    )
    .join(',');
}
